module.exports = __webpack_public_path__ + "static/media/grillme_home.3399eefb.png";